module.exports = __webpack_public_path__ + "static/media/SF_nn_sekundaerlogo_postale_agder_neg.9dab1fe2.pdf";